/* import __COLOCATED_TEMPLATE__ from './synced-source-bulk-row-actions.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type Store from '@ember-data/store';
import type SyncSourceWrapper from 'embercom/models/knowledge-hub/sync-source-wrapper';
import type Folder from 'embercom/models/content-service/folder';
import { isPresent } from '@ember/utils';
import type ContentWrapper from 'embercom/models/content-service/content-wrapper';
import { type KnowledgeHubTableRow } from 'embercom/models/content-service/knowledge-hub-content-wrapper';
import type KnowledgeHubService from 'embercom/services/knowledge-hub-service';

interface Args {
  tableRow: KnowledgeHubTableRow;
}

export default class SyncedSourceBulkRowActions extends Component<Args> {
  @service declare store: Store;
  @service declare knowledgeHubService: KnowledgeHubService;

  get canShowSourceRowActions(): boolean {
    return isPresent(this.syncSource);
  }

  get syncSource(): SyncSourceWrapper | undefined {
    let folder = this.getFolder();
    if (!folder) {
      return undefined;
    }
    return this.getSyncSource(folder);
  }

  get contentWrapper() {
    return this.args.tableRow as ContentWrapper;
  }

  private getFolder(): Folder | undefined {
    let folderId = this.contentWrapper.entityId;
    if (!folderId) {
      return undefined;
    }
    return this.store.peekRecord('content-service/folder', folderId);
  }

  private getSyncSource(folder: Folder): SyncSourceWrapper | undefined {
    let syncSources = this.store.peekAll('knowledge-hub/sync-source-wrapper');
    return syncSources.find((source) => {
      return source.folderId && source.folderId.toString() === folder.id.toString();
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::SyncedSourceBulkRowActions': typeof SyncedSourceBulkRowActions;
    'knowledge-hub/filterable-list/table/cells/synced-source-bulk-row-actions': typeof SyncedSourceBulkRowActions;
  }
}
